const FIRST_SIGNUP_DEMO_KEY = "pendingFirstSignupDemo";

const readStorage = () => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage;
};

export const markPendingFirstSignupDemo = () => {
  try {
    readStorage()?.setItem(FIRST_SIGNUP_DEMO_KEY, "true");
  } catch (_error) {
    // Ignore storage failures so auth flow can continue.
  }
};

export const consumePendingFirstSignupDemo = () => {
  try {
    const storage = readStorage();
    const hasPendingDemo = storage?.getItem(FIRST_SIGNUP_DEMO_KEY) === "true";

    if (hasPendingDemo) {
      storage?.removeItem(FIRST_SIGNUP_DEMO_KEY);
    }

    return hasPendingDemo;
  } catch (_error) {
    return false;
  }
};

export const clearPendingFirstSignupDemo = () => {
  try {
    readStorage()?.removeItem(FIRST_SIGNUP_DEMO_KEY);
  } catch (_error) {
    // Ignore storage failures.
  }
};
